import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Brain, Calendar, MonitorPlay, CheckCircle2 } from 'lucide-react';
export function FeaturesSection() {
  const features = [{
    icon: <BookOpen size={22} className="text-[#586880]" data-id="element-52" />,
    title: 'Material teórico completo',
    description: 'Contenido claro y estructurado para cada nivel, organizado de forma progresiva.',
    bullets: []
  }, {
    icon: <Brain size={22} className="text-[#586880]" data-id="element-53" />,
    title: '+500 actividades didácticas',
    description: 'Actividades para desarrollar pensamiento histórico:',
    bullets: ['análisis de fuentes', 'debates historiográficos', 'ensayos argumentativos']
  }, {
    icon: <Calendar size={22} className="text-[#586880]" data-id="element-54" />,
    title: 'Planificación de clases',
    description: 'Cada año incluye:',
    bullets: ['28 clases estructuradas', 'secuencia pedagógica progresiva']
  }, {
    icon: <MonitorPlay size={22} className="text-[#586880]" data-id="element-55" />,
    title: 'Diapositivas listas',
    description: 'Presentaciones con mapas, líneas de tiempo y esquemas conceptuales.',
    bullets: []
  }];
  return <section className="bg-[#F4F4F2] py-8 px-4 border-y border-[#E2DED6]" data-id="element-56">
      <div className="max-w-4xl mx-auto" data-id="element-57">
        <div className="text-center mb-6" data-id="element-58">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-xl md:text-2xl font-bold text-[#424E60] uppercase mb-2" data-id="element-59">
            UNA COLECCIÓN CREADA PARA FACILITAR TU TRABAJO DOCENTE
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-sm md:text-base text-[#586880] max-w-2xl mx-auto" data-id="element-60">
            Todo lo necesario para enseñar Historia en secundaria.{' '}
            <strong data-id="element-61">Organizado de 1° a 5° año.</strong>
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-62">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="bg-white px-4 py-3 rounded-lg shadow-sm border border-[#E2DED6] flex gap-3 items-start" data-id="element-63">
              <div className="bg-[#F4F4F2] w-10 h-10 rounded-full flex items-center justify-center border border-[#E2DED6] shrink-0 mt-0.5" data-id="element-64">
                {feature.icon}
              </div>
              <div className="flex-1 min-w-0" data-id="element-65">
                <h3 className="text-sm font-bold text-[#424E60] mb-1" data-id="element-66">
                  {feature.title}
                </h3>
                <p className="text-[#586880] text-xs leading-snug" data-id="element-67">
                  {feature.description}
                </p>
                {feature.bullets.length > 0 && <div className="flex flex-wrap gap-x-3 gap-y-1 mt-1.5" data-id="element-68">
                    {feature.bullets.map((bullet, i) => <span key={i} className="flex items-center gap-1 text-[#424E60] text-xs" data-id="element-69">
                        <CheckCircle2 className="text-[#4A7C59] shrink-0" size={12} data-id="element-70" />
                        {bullet}
                      </span>)}
                  </div>}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}